import React from 'react';

import {useDataValue} from 'globals/contexts/dataContext';

import LandingSection from 'containers/commercialPage/landingSection';
import ProjectListSection from 'containers/commercialPage/projectListSection';
import BannerSection from 'containers/commercialPage/bannerSection';

import Footer from 'containers/footer';

import './commercialPage.css';

const CommercialPage = () => {
  const [{content, currentLanguage}] = useDataValue();
  const pageContent = content['content'][currentLanguage]['pages']['commercial'];
  return <div id="commercial" className="page">
    <LandingSection content={pageContent['landing']} />
    <ProjectListSection content={pageContent['projects']} />
    {/* <AboutSection content={pageContent['about']} />
    <EventSection content={pageContent['event']} />
    <ShowcaseSection content={pageContent['showcase']} />
    <CollaborationSection content={pageContent['collaboration']} /> */}
    <BannerSection content={pageContent['banner']} />
    <Footer />
  </div>;
};

export default CommercialPage;